module.exports = __WEBPACK_EXTERNAL_MODULE_545__;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 545
// module chunks = 0